import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Card, Table, Spinner } from 'react-bootstrap';
import api from '../../services/api';
import { formatarHora } from '../../util/utils';

export default function AgendaPaciente() {
  const { patient } = useSelector(state => state.patient);
  const [agenda, setAgenda] = useState([]);
  const [loading, setLoading] = useState(false);
  const abortController = new AbortController(); // abort controller cancela requisição se o componente for desmontado
  const { signal } = abortController;

  useEffect(() => {
    async function loadAgendaPac() {
      setLoading(true);
      try {
        const { data } = await api.get(
          `pacientes/${patient.codPac}/agendas?situacao=Agendada&order=DESC`,
          { signal }
        );
        setAgenda(data);
      } catch (error) {
        toast.error(error?.response?.data?.error || 'Erro ao carregar agenda');
      } finally {
        setLoading(false);
      }
    }

    loadAgendaPac();

    return () => {
      abortController.abort();
    };
  }, []);

  return (
    <Card className="mt-2">
      <Card.Header className="font-weight-bold">Meus agendamentos</Card.Header>
      <Card.Body>
        {loading ? (
          <div className="d-flex justify-content-center align-items-center">
            <Spinner animation="border" variant="dark" />
          </div>
        ) : (
          <Table responsive="sm" striped bordered size="sm" variant="primary">
            <thead>
              <tr>
                <th>Atividade</th>
                <th>Data</th>
                <th>Horário</th>
                <th>Médico</th>
                <th>Convênio</th>
              </tr>
            </thead>
            <tbody>
              {agenda.map(a => (
                <tr key={a.codAgenda}>
                  <td>{a.procedimento}</td>
                  <td>{a.dataFormatada}</td>
                  <td>{formatarHora(a.horario)}</td>
                  <td>{a.medico}</td>
                  <td>{a.convenio}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </Card.Body>
    </Card>
  );
}
